import {Component, Input, OnDestroy} from '@angular/core'

@Component({
  selector: 'dmmp-pdf-viewer',
  templateUrl: './pdf-viewer.component.html'
})
export class PdfViewerComponent implements OnDestroy {

  @Input() pdfSrc
  @Input() defaultClass

  ngOnDestroy(): void {
    this.pdfSrc = ''
  }
}
